import { ReactNode } from 'react';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from '@azure/msal-react';
import { useAuth } from '@/core/hooks/useAuth';
import { Button } from '@/shared/components/ui/button';
import { Shield } from 'lucide-react';

interface ProtectedRouteProps {
  children: ReactNode;
}

/**
 * ProtectedRoute guards routes that require authentication.
 * Shows a login prompt for unauthenticated users.
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  return (
    <>
      <AuthenticatedTemplate>{children}</AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <LoginPrompt />
      </UnauthenticatedTemplate>
    </>
  );
}

function LoginPrompt() {
  const { login } = useAuth();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-6">
      <Shield className="h-16 w-16 text-muted-foreground" />
      <div className="text-center space-y-2">
        <h2 className="text-2xl font-semibold">Authentication Required</h2>
        <p className="text-muted-foreground">
          Please sign in with your Microsoft account to access this application.
        </p>
      </div>
      <Button size="lg" onClick={login}>
        Sign in with Microsoft
      </Button>
    </div>
  );
}
